/**
 * Converts hex to rgba
 * @param {string} hexcode
 * @param {number} opacity from 0 to 1
 * @returns A rgba style for js styling
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/98e335-code/t/469fd1)
 */
export function rgba(hexcode, opacity) {
  var values = [hexcode.substring(1, 3), hexcode.substring(3, 5), hexcode.substring(5, 7)].map(function (string) {
    return parseInt(string, 16);
  });
  return "rgba(".concat(values[0], ", ").concat(values[1], ", ").concat(values[2], ", ").concat(opacity, ")");
}